export default "__VITE_PUBLIC_ASSET__1d2744fa__"